export default "__VITE_ASSET__$68TDJDw__"